import React from 'react'
import {
  Grid,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  FormHelperText,
} from '@material-ui/core'

export default function WCurrencyField({data, onChange, tabActive}) {
  return (
    <Grid item xs={6}>
      <FormControl fullWidth variant="outlined" className="ap-textfield" style={{width: 320}}>
        <InputLabel htmlFor="outlined-adornment-amount">{data.name}</InputLabel>
        <OutlinedInput
          id="outlined-adornment-amount"
          value={data.value}
          onChange={e => {
            onChange(e, data.key)
          }}
          startAdornment={<InputAdornment position="start">$</InputAdornment>}
          labelWidth={60}
        />
        <FormHelperText>
          {(() => {
            if (
              (tabActive === 'upcoming' && data.is_required) ||
              (tabActive === 'ongoing' && data.is_required_return)
            ) {
              return 'required*'
            } else {
              return 'optional'
            }
          })()}
        </FormHelperText>
      </FormControl>
    </Grid>
  )
}
